import { render, staticRenderFns } from "./YearlyLiveStockTable.vue?vue&type=template&id=3c5ace02&scoped=true&"
import script from "./YearlyLiveStockTable.vue?vue&type=script&lang=ts&"
export * from "./YearlyLiveStockTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ace02",
  null
  
)

export default component.exports